import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { baseUrl } from "../../../Utils/GlobalStaticVariable";

import { toast } from 'react-toastify';
export const getChannelWebHooks = createAsyncThunk('getChannelWebHooks', async (arg, {
  rejectWithValue
}) => {
  try {
    const { data } = await axios.get(`${baseUrl}webhooks/channel/${arg}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        }
      }
    );
    return data;
  }
  catch (error) {

    return rejectWithValue(error.response.data.message);

  }
});



export const saveWebHook = createAsyncThunk('saveWeebHook', async (arg, {
  rejectWithValue
}) => {
 

  try {
    const { data } = await axios.post(`${baseUrl}webhooks`, arg,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        }
      }
    );
    return data;
  }
  catch (error) {

    return rejectWithValue(error.response.data.message);

  }
});

export const updateWebHook = createAsyncThunk('updateWebHook', async (arg, {
  rejectWithValue
}) => {
  const {id} = arg
  try {
    const { data } = await axios.put(`${baseUrl}webhooks/${id}`, arg,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        }
      }
    );
    return data;
  }
  catch (error) {

    return rejectWithValue(error.response.data.message);

  }
});

export const delWebHook = createAsyncThunk('delWebHook', async (arg, {
  rejectWithValue
}) => {
  console.log('argument here ',arg)
  const {Id} = arg
  try {
     const { data } = await axios.delete(`${baseUrl}webhooks/`+arg,    
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        }
      }
    );
    console.log('here is deletd data api response',data)
    return data;
  }
  catch (error) {

    return rejectWithValue(error.response.data.message);

  }
});




export const singleChannelWebhooks = createSlice({
  name: 'SingleChannelHooks',
  initialState: {
    value: [],
    loading: false,
    message: "",
    role: null
  },
  reducers: {
    emptyHooks: (state) => {
      state.value = [];
    }
  },

  extraReducers: (builder) => {
    builder.addCase(getChannelWebHooks.pending, (state, action) => {
      // toast.loading('Fetching Hooks');
      state.loading = true;
    });
    builder.addCase(getChannelWebHooks.fulfilled, (state, action) => {
      // toast.dismiss();
      // toast.success('Fetched Hooks');
      state.loading = false;
      state.value = action.payload.data;
    });
    builder.addCase(getChannelWebHooks.rejected, (state, action) => {
      // toast.dismiss();
      // toast.error('Fetching Hooks Failed');
      state.loading = false;
      state.message = action.payload;
      state.isSuccess = false;
    });
    builder.addCase(saveWebHook.pending, (state, action) => {
      toast.loading('Creatring WebHook');

    });
    builder.addCase(saveWebHook.fulfilled, (state, action) => {
      toast.dismiss();
      toast.success('Created WebHook');

    });
    builder.addCase(saveWebHook.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Creating WebHooks Failed');

    });
    builder.addCase(updateWebHook.pending, (state, action) => {
      toast.loading('Updating WebHook');

    });
    builder.addCase(updateWebHook.fulfilled, (state, action) => {
      toast.dismiss();
      toast.success('Updated WebHook');

    });
    builder.addCase(updateWebHook.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Updating WebHooks Failed');

    });
    builder.addCase(delWebHook.pending, (state, action) => {
      toast.loading('Deleting WebHook');

    });
    builder.addCase(delWebHook.fulfilled, (state, action) => {
      toast.dismiss();
      toast.success('Deleted WebHook');

    });
    builder.addCase(delWebHook.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Error while deleting WebHook');

    });
  },
});


export const { emptyHooks } = singleChannelWebhooks.actions;
export default singleChannelWebhooks;


